import React from "react";
import { Modal } from "reactstrap";
import Loader from "react-loader-spinner";

const MessagesApprovalSendConfirmModal = ({
  isOpen,
  loading,
  onConfirm,
  onCancel,
}) => (
  <Modal
    centered
    isOpen={isOpen}
    toggle={loading ? undefined : onCancel}
    className="messages-approval-send-confirm-modal"
    backdrop="static"
  >
    <div className="messages-approval-send-confirm-content">
      <button
        type="button"
        className="messages-approval-send-confirm-close"
        onClick={onCancel}
        disabled={loading}
        aria-label="Close"
      >
        ×
      </button>
      <div className="messages-approval-send-confirm-icon" aria-hidden="true">
        !
      </div>
      <p className="messages-approval-send-confirm-title">Send Message?</p>
      <p className="messages-approval-send-confirm-subtitle">
        Are you sure you want to send this approved message?
      </p>
      <div className="messages-approval-send-confirm-actions">
        <button
          type="button"
          className="messages-approval-send-confirm-btn cancel"
          onClick={onCancel}
          disabled={loading}
        >
          Cancel
        </button>
        <button
          type="button"
          className="messages-approval-send-confirm-btn confirm"
          onClick={onConfirm}
          disabled={loading}
        >
          {loading ? (
            <Loader type="ThreeDots" color="#ffffff" height={20} width={40} />
          ) : (
            "Yes"
          )}
        </button>
      </div>
    </div>
  </Modal>
);

export default MessagesApprovalSendConfirmModal;
